import React from "react";
import Skeleton from "@/components/ui/Skeleton";

const RouteFallbackSkeleton: React.FC = () => {
  return (
    <div className="p-6 space-y-4">
      {/* Page header area */}
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <Skeleton className="h-7 w-48" />
          <Skeleton className="h-4 w-72" />
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-9 w-28 rounded-lg" />
          <Skeleton className="h-9 w-9 rounded-full" />
        </div>
      </div>

      {/* Tab bar placeholder */}
      <div className="flex items-center gap-1 rounded-lg border border-white/10 bg-white/5 p-1">
        {Array.from({ length: 4 }, (_, i) => (
          <Skeleton key={i} className="h-9 w-28 rounded-md" />
        ))}
      </div>

      {/* Content area */}
      <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/5">
        {/* Table header */}
        <div className="bg-white/5 px-4 py-3 flex gap-6">
          {["w-32", "w-24", "w-20", "w-20", "w-16", "w-16"].map((w, i) => (
            <Skeleton key={i} className={`h-4 ${w}`} />
          ))}
        </div>
        {/* Table rows */}
        <div className="divide-y divide-white/5">
          {Array.from({ length: 6 }, (_, i) => (
            <div key={i} className="px-4 py-3 flex gap-6">
              {["w-32", "w-24", "w-20", "w-20", "w-16", "w-16"].map(
                (w, j) => (
                  <Skeleton key={j} className={`h-4 ${w}`} />
                )
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RouteFallbackSkeleton;
